import React from "react";
import { styled } from "../../stitches.config";

import { buttonInputStateTransition } from "./AuthDialogComponents";
import Icon from "../../components/Icon";

const AcrylicPanelOuter = styled("div", {
  background: "rgba(255, 255, 255, 0.01)",
  border: "0.03125rem solid rgba(255, 255, 255, 0.5)", // 0.5px/16px
  borderRadius: "2rem", // 32px/16px
  boxShadow:
    "0px 0.7px 1.4px rgba(113, 81, 78, 0.06), 0px 2px 4px rgba(113, 81, 78, 0.08), 0px 4.8px 9.6px rgba(113, 81, 78, 0.1), 0px 16px 32px rgba(113, 81, 78, 0.16)",
  padding: "0.09375rem", // padding + border = 2px, so padding is 1.5px/16px
  boxSizing: "border-box",
  backdropFilter: "blur(1rem)",
  position: "relative",
  width: "25rem",
});

const AcrylicPanelInner = styled("div", {
  background: "rgba(255, 255, 255, 0.8)",
  borderRadius: "1.875rem", // 30px/16px
  padding: "2.875rem", // 46px/16px
});

const LogoContainer = styled("div", {
  width: "$6",
  height: "$6",
  marginBottom: "2rem",
});

const Logo = React.memo(function Logo() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.91819 6.25172C4.42941 6.25172 4.92916 6.0944 5.35423 5.79964C5.77929 5.50488 6.11059 5.08593 6.30623 4.59577C6.50187 4.10561 6.55306 3.56624 6.45332 3.04589C6.35359 2.52553 6.10741 2.04756 5.74592 1.6724C5.38443 1.29725 4.92386 1.04177 4.42246 0.938263C3.92105 0.834758 3.40133 0.887882 2.92902 1.09091C2.45671 1.29395 2.05302 1.63777 1.769 2.0789C1.48497 2.52004 1.33337 3.03867 1.33337 3.56922C1.33423 4.28039 1.60683 4.96218 2.09139 5.46505C2.57595 5.96792 3.23292 6.25083 3.91819 6.25172Z"
        fill="#231A1A"
        fillOpacity="0.2"
      />
      <path
        d="M28.064 25.7607C27.5528 25.7607 27.0531 25.9181 26.628 26.2128C26.2029 26.5076 25.8716 26.9265 25.676 27.4167C25.4803 27.9069 25.4291 28.4462 25.5289 28.9666C25.6286 29.4869 25.8748 29.9649 26.2363 30.3401C26.5978 30.7152 27.0583 30.9707 27.5597 31.0742C28.0611 31.1777 28.5809 31.1246 29.0532 30.9216C29.5255 30.7185 29.9292 30.3747 30.2132 29.9336C30.4972 29.4924 30.6488 28.9738 30.6488 28.4432C30.6481 27.732 30.3755 27.0502 29.8909 26.5473C29.4064 26.0444 28.7493 25.7615 28.064 25.7607Z"
        fill="#231A1A"
        fillOpacity="0.2"
      />
      <path
        d="M27.4262 8.95501C26.6207 8.15521 25.6628 7.5391 24.6143 7.14625C23.5657 6.75339 22.4495 6.59247 21.3375 6.67382C18.0357 6.81784 14.3939 8.72555 12.0589 11.5295C10.6633 13.1494 9.83992 15.2136 9.72388 17.3832C9.68461 18.8654 10.0475 20.3291 10.7711 21.6076L10.7684 21.6124C10.1006 21.707 9.42101 21.6474 8.77809 21.4377C8.13517 21.2279 7.54485 20.8734 7.04935 20.3993C6.059 19.396 5.66674 17.5671 6.00025 15.5028C6.64321 11.5252 9.60547 7.88787 13.9235 5.77326C15.7913 4.85877 18.0958 3.97548 20.2005 4.02637C20.2719 4.02889 20.3424 4.00855 20.4023 3.9681C20.4622 3.92765 20.5087 3.86906 20.5354 3.80027L21.6617 0.879177C21.6823 0.82683 21.6908 0.77024 21.6866 0.71389C21.6824 0.657539 21.6657 0.602974 21.6377 0.554499C21.6097 0.506024 21.5712 0.464971 21.5253 0.43459C21.4794 0.404209 21.4273 0.385331 21.3731 0.379448C18.3956 0.104381 15.1026 1.09952 12.3994 2.42109C7.02391 5.05319 3.31507 9.71396 2.47876 14.8884C1.94403 18.1964 2.70078 21.1708 4.55474 23.0492C5.30626 23.8002 6.19369 24.3892 7.16579 24.7823C8.13788 25.1754 9.17536 25.3648 10.2184 25.3395C10.3571 25.3395 10.5015 25.3366 10.6439 25.3304C13.9462 25.1864 17.5879 23.2787 19.922 20.4747C21.3178 18.8549 22.1414 16.7907 22.2575 14.621C22.2968 13.1388 21.9339 11.6751 21.2103 10.3966V10.3918C21.8781 10.2965 22.558 10.3559 23.201 10.5656C23.8441 10.7754 24.4345 11.1303 24.9297 11.6049C25.9201 12.6082 26.3119 14.4371 25.9784 16.5013C25.3354 20.479 22.3736 24.1163 18.0551 26.2309C16.1313 27.1733 13.8518 28.0551 11.6847 27.973C11.6126 27.9695 11.5412 27.9893 11.4804 28.0296C11.4196 28.0699 11.3724 28.1288 11.3452 28.1982L10.223 31.1077C10.2024 31.1605 10.1939 31.2175 10.1982 31.2743C10.2025 31.3311 10.2195 31.386 10.2479 31.4348C10.2762 31.4835 10.315 31.5248 10.3614 31.5553C10.4077 31.5857 10.4603 31.6046 10.5149 31.6103C11.0306 31.6584 11.5524 31.6857 12.0783 31.6857C14.6479 31.6857 17.2887 30.7031 19.5788 29.5812C24.9538 26.9491 28.6626 22.2883 29.4994 17.1144C30.0374 13.8078 29.2806 10.8334 27.4262 8.95501ZM18.6953 14.4251C18.6213 15.7744 18.1015 17.0559 17.2234 18.0538C16.4082 19.0147 15.4352 19.8178 14.3495 20.4257C13.6752 19.6423 13.2988 18.6309 13.2907 17.5805C13.3646 16.2314 13.8843 14.9499 14.7621 13.9518C15.5775 12.991 16.5507 12.1879 17.6365 11.5799C18.3104 12.3636 18.6867 13.3748 18.6953 14.4251Z"
        fill="#231A1A"
        fillOpacity="0.2"
      />
    </svg>
  );
});

const CloseButton = styled("button", {
  ...buttonInputStateTransition,
  border: "none",
  background: "transparent",
  borderRadius: "50%",
  width: "2rem",
  height: "2rem",
  position: "absolute",
  right: "1rem",
  top: "1rem",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:hover": {
    background: "rgba(184, 162, 156, 0.1)",
  },
  "&:active": {
    background: "rgba(184, 162, 156, 0.2)",
  },
});

/** An empty dialog, designed to contain dialog components like `<Title>`. */
export function AuthDialog({
  children,
  closable = true,
  onClose,
}: {
  children: React.ReactNode;
  closable?: boolean;
  onClose?: () => void;
}) {
  return (
    <AcrylicPanelOuter>
      <AcrylicPanelInner>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        {children}
        {closable && (
          <CloseButton onClick={onClose}>
            <Icon icon="Cross" color="rgba(35, 26, 26, 0.5)" />
          </CloseButton>
        )}
      </AcrylicPanelInner>
    </AcrylicPanelOuter>
  );
}
